import { useEffect, useState } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import 'react-toastify/dist/ReactToastify.css';
import Button from '../../components/common/Button/button';
import InputDate from '../../components/common/Input/inputDate';
import InputFile from '../../components/common/Input/inputFile';
import InputMultyLang from '../../components/common/Input/inputMultyLang';
import InputNumber from '../../components/common/Input/inputNumber';
import InputPhone from '../../components/common/Input/inputPhone';
import InputSelect from '../../components/common/Input/inputSelect';
import InputText from '../../components/common/Input/inputText';
import ToastNotfication from '../../components/toastNotfication';
import { useArea } from '../../features/area/useArea';
import { useClient } from '../../features/client/useClient';
import useImageUpload from '../../features/fileUplad/useImageUpload';
import { useSerivePointTypes } from '../../features/servicePointType/useServicePointType';
import { useHandleInputChange } from '../../hook/useHandleInputChange';
import { useInvalidLangs } from '../../hook/useInvalidLangs';
import { useOnSavePostClicked } from './hook/useOnSavePostClicked';
import { initialState } from './initialStates/create';
import MultipleSelect from "../../components/common/MultipleSelect/MultipleSelect";
import _ from 'lodash';
const Index = () => {
    const { t, i18n } = useTranslation();
    const lang = i18n.language
    const { allClients, fetchAllData } = useClient();
    const { allAreas, fetchAllData: getAllAreas } = useArea();
    const { allservicepointTypes, fetchAllData: allServicePoints } = useSerivePointTypes();
    const [activeTab, setActiveTab] = useState('az');
    const languages = ['az', 'en', 'ru'];
    const { formState, formError, handleInputChange } = useHandleInputChange(initialState);
    const { uploadError, imageUrl, isLoading, handleFileChange } = useImageUpload();
    const { response, loading, formPostError, onSavePostClicked } = useOnSavePostClicked(formState, imageUrl);
    const { invalidLangs } = useInvalidLangs(formPostError, loading, response);
    useEffect(() => {
        const debouncedFetchData = _.debounce(() => {
            fetchAllData();
            allServicePoints();
            getAllAreas();
        }, 300);

        debouncedFetchData();
        return debouncedFetchData.cancel;
    }, []);
    const handleClientChange = (selected) => {
        handleInputChange({ target: { name: 'client_ids', value: selected } });
    };
    return (
        <HelmetProvider>
            <div className="page-wrapper">
                <div className="page-content">
                    <div className="row">
                        <div className="col-xl-9 mx-auto">
                            <div className="card">
                                <div className="card-body">
                                    <div className="mb-4">
                                        <ul className="nav nav-tabs">
                                            {languages.map(lang => (
                                                <li className="nav-item" key={lang}>
                                                    <button
                                                        className={`nav-link ${invalidLangs?.includes(lang) ? 'invalid-bg' : ''}   ${activeTab === lang ? 'active' : ''}`}
                                                        onClick={() => setActiveTab(lang)}
                                                    >
                                                        {lang.toUpperCase()}
                                                    </button>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                    <div className="p-4 border rounded">
                                        <form className="row g-3" >
                                            <InputMultyLang
                                                label={`${t('properties.name')} (${activeTab})`}
                                                id={`name-${activeTab}`}
                                                name="name"
                                                value={formState.name?.[activeTab] || ''}
                                                error={formPostError?.[`name.${activeTab}`]}
                                                onChange={(e) => handleInputChange(e, activeTab)}
                                            />
                                            <InputMultyLang
                                                label={`${t('properties.address')} (${activeTab})`}
                                                id={`address-${activeTab}`}
                                                name="address"
                                                value={formState.address?.[activeTab] || ''}
                                                error={formPostError?.[`address.${activeTab}`]}
                                                onChange={(e) => handleInputChange(e, activeTab)}
                                            />

                                            <InputText
                                                name="relevant_person"
                                                label={t('properties.relevant_person')}
                                                formError={formError}
                                                value={formState?.relevant_person}
                                                onChange={handleInputChange}
                                            />

                                            <InputPhone
                                                name="phone"
                                                label={t('properties.phone')}
                                                formError={formPostError}
                                                value={formState?.phone}
                                                onChange={handleInputChange}
                                            />
                                            <InputNumber
                                                name="latitude"
                                                label={t('properties.latitude')}
                                                formError={formPostError}
                                                value={formState?.latitude}
                                                onChange={handleInputChange}
                                            />
                                            <InputNumber
                                                name="longitude"
                                                label={t('properties.longitude')}
                                                formError={formPostError}
                                                value={formState?.longitude}
                                                onChange={handleInputChange}
                                            />

                                            <InputDate
                                                label={t("properties.openingTime")}
                                                id="opening_time"
                                                name="opening_time"
                                                value={formState.opening_time}
                                                onChange={(e) => handleInputChange(e)}
                                                error={formError?.[`opening_time`]}
                                            />
                                            <InputDate
                                                label={t("properties.closingTime")}
                                                id="opening_time"
                                                name="closing_time"
                                                value={formState.closing_time}
                                                onChange={(e) => handleInputChange(e)}
                                                error={formError?.[`closing_time`]}
                                            />

                                            <InputSelect
                                                field='name'
                                                name="area_id"
                                                label={t("properties.area")}
                                                options={allAreas}
                                                value={formState.area_id}
                                                onChange={handleInputChange}
                                                formError={formError}
                                                lang={lang}
                                            />



                                            <InputSelect
                                                field='name'
                                                name="servicepoint_type_id"
                                                label={t("properties.servicePointType")}
                                                options={allservicepointTypes}
                                                value={formState.servicepoint_type_id}
                                                onChange={handleInputChange}
                                                formError={formError}
                                                lang={lang}
                                            />
                                            <MultipleSelect
                                                options={allClients}
                                                onSelectionChange={handleClientChange}
                                                selectedValues={formState.client_id}
                                                name="client_id"
                                                field="phone"
                                                field_second="name"
                                                label={t('clients.clients')}
                                                formError={formError}
                                            />

                                            {/* <
                                                options={allClients}
                                            onSelectionChange={handleInputChange}
                                            selectedValues={formState.client_id}
                                            label={t('properties.client')}
                                            name="client_id"
                                            field="phone"
                                            field_second="name"
                                            na_text={t("common.no_name")}
                                            formError={formError}
                                            /> */}

                                            <InputFile
                                                label={t('media.file')}
                                                id="image"
                                                onChange={handleFileChange}
                                            />
                                            <Button
                                                label={t('properties.save')}
                                                onClick={onSavePostClicked}
                                                isLoading={isLoading || loading}
                                                disabled={isLoading}
                                            />


                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ToastNotfication response={response || uploadError} />
        </HelmetProvider>
    );
};

export default Index;